import { StyledOrderStatus } from './style';
import { StatusComponent } from './StatusComponent/StatusComponent';
import { Icon } from '../../../../../ui';
import { useIntl } from 'react-intl';

interface OrderStatusProps {
  transactionStatus: Status;
  isWholesale?: boolean;
}

export type Status = (typeof ALL_STATUSES)[number] | string;
export const ALL_STATUSES = ['new', 'confirmed', 'sent', 'delivered'];

const WHOLESALE_STEP_3_STATUSES = ['pending_send', 'partially_sent', 'sent'];

const getWholesaleStep = (status: string): number => {
  if (status === 'new') return 1;
  if (status === 'confirmed') return 2;
  if (WHOLESALE_STEP_3_STATUSES.includes(status)) return 3;
  if (status === 'delivered' || status === 'done') return 4;
  return 1;
};

export const OrderStatus = ({
  transactionStatus,
  isWholesale = false,
}: OrderStatusProps) => {
  const intl = useIntl();

  const isCanceled = transactionStatus === 'canceled';
  const effectiveStatus = isCanceled ? 'delivered' : transactionStatus;

  const isSelected = (status: string, index: number) => {
    if (isWholesale) {
      const currentStep = getWholesaleStep(effectiveStatus);
      return index + 1 === currentStep;
    }
    return status === effectiveStatus;
  };

  return (
    <StyledOrderStatus>
      {ALL_STATUSES.map((status, index) => {
        return (
          <>
            <StatusComponent
              step={index + 1}
              label={
                isCanceled && index === 3
                  ? intl.formatMessage({ id: 'transactions.status.canceled' })
                  : intl.formatMessage({ id: `status.${status}` })
              }
              selected={isSelected(status, index)}
            />
            {ALL_STATUSES.length !== index + 1 && (
              <Icon name={'arrow-right-big'} className="arrow-right-big" />
            )}
          </>
        );
      })}
    </StyledOrderStatus>
  );
};
